module.exports = __webpack_public_path__ + "img/Distribution-of-Packages-by-Continent-768x658.4edb2501.png";